import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCall, MdEmail, MdLocationPin, MdSearch, MdWhatsapp } from "react-icons/md";
import { AiFillWechat } from "react-icons/ai";

export default function ContactUsContent(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}


	

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<div 
				className="MainBodySection bg-secondary"
				style={{
					paddingBottom: "50px",
					paddingTop: "50px"
				}}
			>
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h1
								className="text-center font-bold text-extra mb-3"
							>
								Contact Us
							</h1>
							<h6 className="text-center mb-3">
								We welcome enquiries from partners and organisations across Africa.<br/>
								Please reach out to discuss your programme or project.
							</h6>
							<hr/>
						</div>

						

						<div className="col-md-12 text-center">
							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									
									window.open('mailto:info@kobekonsult.com', '_blank')
									
								}}
								className="font-bold text-light"
							>
								<MdEmail
									className="text-extra"
								size={32}/> info@kobekonsult.com
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									window.open('tel:+255754300767', '_blank')
								}}
								className="font-bold text-light"
							>
								<MdCall
									className="text-extra"
								size={32}/>  
								+255754300767 | +255783350234
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									window.open("https://wa.me/+255754300767", "_blank");
							
								}}
								className="font-bold text-light"
							>
								<MdWhatsapp
									className="text-extra"
								size={32}/> Click to chat with us on WhatsApp
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								className="font-bold text-light"
							>
								<MdLocationPin
									className="text-extra"
								size={32}/>  Kijitonyama | Off - Shekilango Road 
							</h6>

							
							
						</div>

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}